module.exports = __webpack_public_path__ + "static/WOW-c9c0f549b186adc972205d57598aa022.png";